module.exports = __webpack_public_path__ + "static/IBMPlexSans-Medium-Latin1-5cc4e63043fcaea76eafacdb8987c55f.woff2";